import css from 'styled-jsx/css';

export default css`
    .Modal {
        transition: opacity 0.3s ease;
    }

    .ModalContainer {
        max-height: 100%;
        overflow-y: auto;
    }

    :global(body) {
        overflow: hidden;
    }
`;
